import React from "react";

const Menu = (props) => {
  const { navMenu, info, onActive, activeHandler } = props;

  return (
    <div className="flex flex-col lg:flex-row gap-12 lg:items-center ">
      <ul className="text-xs gap-4 flex flex-col lg:flex-row order-2 lg:order-1 text-indigo-300">
        <li>{info.email}</li>
        <li>{info.tel}</li>
      </ul>
      <ul className="flex flex-col lg:flex-row gap-8 lg:gap-4 lg:order-2 select-none">
        {navMenu.map((menu, index) => (
          <li
            data-id={menu.name.replace(" ", "")}
            key={`menu${index}`}
            onClick={() => activeHandler(menu.id)}
            className={[
              "border-b-2 transition duration-200 ease-in-out py-1",
              onActive === menu.id
                ? "border-b-indigo-300 text-white "
                : "border-b-transparent text-indigo-400",
            ].join(" ")}
          >
            <a className="px-2 py-1 capitalize" href={menu.src}>
              {menu.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Menu;
